"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var VideoIcon = function VideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width,
    height: props.height,
    viewBox: "0 0 20 20",
    fill: "none",
    className: props.className
  }, /*#__PURE__*/React.createElement("rect", {
    x: "2.25",
    y: "4.96814",
    width: "10.7532",
    height: "9.81065",
    rx: "1.25",
    stroke: props.color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2237 7.52987L16.3388 5.85292C17.0051 5.49426 17.8129 5.97685 17.8128 6.7335L17.8124 13.2667C17.8124 14.0233 17.0047 14.5058 16.3385 14.1472L13.2234 12.4705",
    stroke: props.color,
    strokeWidth: "1.5"
  }));
};
var defaultProps = {
  color: _constants.colors.mediumGrey,
  width: 20,
  height: 20
};
VideoIcon.defaultProps = defaultProps;
var _default = exports["default"] = VideoIcon;